import { getSelectedSiteIds } from './get-selected-site-ids';
import { getSitesByIds } from './get-sites-by-ids';
export const getSelectedSites = () => getSitesByIds(getSelectedSiteIds());
//# sourceMappingURL=get-selected-sites.js.map